import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const AppLinksMetaTags = () => {
  const location = useLocation();

  // Handle root (/) separately
  const cleanPath = location.pathname === '/' ? 'home' : location.pathname.replace(/^\/+/, '');
  const deepLinkUrl = `QUSHi://${cleanPath}`;
  const webUrl = `https://app.qushi.io/${cleanPath}`;


  return (
    <Helmet>
      {/* iOS App Links */}
      <meta property="al:ios:url" content={deepLinkUrl} />
      <meta property="al:ios:app_store_id" content="P8U5Y3W9X8" />
      <meta property="al:ios:app_name" content="QUSHi" />

      {/* Android App Links */}
      <meta property="al:android:url" content={deepLinkUrl} />
      <meta property="al:android:package" content="com.qushi.app" />
      <meta property="al:android:app_name" content="QUSHi" />

      {/* Web fallback */}
      <meta property="al:web:url" content={webUrl} />
    </Helmet>
  );
};

export default AppLinksMetaTags;
